<template>
  <div class="page_all">
    <loading
      :active.sync="isLoading"
      :on-cancel="onCancel"
      :is-full-page="fullPage"></loading>
    <div class="return_link">
      <router-link to="/setting">＞ 設定</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">プライマリー言語</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_group">プライマリー言語設定</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content_top">
              <div class="index_name">プライマリー言語</div>
              <div class="select_group">
                <div>
                  <select class="pull_group form-select" v-model="languageId">
                    <option v-for="language in languages"  v-bind:key="language.language_id" v-bind:value="language.language_id">
                      {{ language.language_name }}
                    </option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              翻訳されてない言語を設定している端末に対して、優先的に表示する言語です。
            </td>
          </tr>
          <tr>
            <td class="td_content_bottom">
              <button class="btn_general" @click="primaryLanguageUpdate">更新</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    "loading":Loading
  },
  data: function() {
    return {
      languages: null,
      languageId: 1,
      // メッセージ
      message: "",

      isLoading: false,
      fullPage: true      
    }
  },
	mounted() {
    this.primaryLanguageDetail()
  },
  methods: {
    async primaryLanguageDetail() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'primary-language/detail', {
          params: {
            municipality_key: this.$store.getters.getStateMunicipalityKey
          }
        })
        console.log(response.data)
        this.languages = response.data.language
        this.languageId = response.data.municipality[0].primary_language
        this.message = ""

      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async primaryLanguageUpdate() {
      this.isLoading = true
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'primary-language/update', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          language_kind: this.languageId
        })
        this.message = ""
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.isLoading = false
      
      this.primaryLanguageDetail()
    },
    onCancel:function() {
      console.log('User cancelled the loader.')
    },
  },
}
</script>

<style scoped>
table th.th_group {
  text-align: left;
  padding-left: 10px;
}
table tr {
  border: none;
}
table td.td_content_top {
  display: flex;
  border: none;
  padding: 20px 0px 20px 20px;
}
table td.td_content_middle {
  text-align: left;
  border: none;
  padding: 0px 0px 0px 20px;
}
table td.td_content_bottom {
  text-align: center;
  border: none;
  padding: 0px 0px 0px 20px;
}
.index_name {
  margin: 0 20px 0 0;
  padding: 0px 0px 5px 0px;
}
.select_group {
  justify-content: space-between;
}
.pull_group {
  /* height: 25px; */
  width: 200px;
}
.btn_general {
  margin: 20px 0 20px 0;
  width: 80px;
}
</style>